/**
 * Veri kartı "İdari / Teknik Tedbirler" formu — saf yardımcı (store/Vue yok).
 * Seçici (`filter-select`) kütüphane politikası dokümanlarını verir; sunucuya yalnız kimlik gider. Kaynaklar, kategori
 * ve not bu formun konusu değil: gönderilmez, backend mevcut değerlerle birleştirir (`{...existing, ...item}`).
 */
const ref = (i) => (i && i._id ? { _id: i._id } : null);

export const measuresPayload = (node, form) => ({
  _id: node._id,
  administrativeMeasures: (form.administrativeMeasures ?? []).map(ref).filter(Boolean),
  technicalMeasures: (form.technicalMeasures ?? []).map(ref).filter(Boolean),
});
